import {handleActions} from 'redux-actions';
import * as type from './actionTypes'
const initState = {
    arrList: [],
    codeResult:'',
    confirmPayResult:null,
    type:'',
    ocrType:'',
    getSendCode: {
        data:{},
        istrue: false
    },
    applicantObj: {
        applicantName: '',
        credentialNo: '',
        phoneNo: '',
        email: '',
    },
    insuredObj: {
        insuredName: '',
        credentialNo: '',
        phoneNo: '',
        email: '',
    },
}
   

const actions = {}
/*ocr识别*/
actions[type.OCR_IDENTIFYSTART] = (state, action) => {
    return{
        ...state,
        type:'OCRIDENTIFYSTART'
    }
}
actions[type.OCR_IDENTIFYSUCCESS] = (state, action) => {
    return{
        ...state,
        data:action.payload.data.result,
        ocrType:action.payload.type,
        type:'OCRIDENTIFYSUCCESS'
    }
}
actions[type.OCR_IDENTIFYERROR] = (state, action) => {
    return{
        ...state,
        data:{},
        type:'OCRIDENTIFYERROR'
    }
}
actions[type.ADDRESS_SELECTSUCESS] = (state, action) => {
    return{
        ...state,
        arrList:action.payload,
        type:'addressSuccess'
    }
}
actions[type.ADDRESS_SELECTERROR] = (state, action) => {
    return{
        ...state,
        action,
        type:'addressError'
    }
}
actions[type.PHONE_VERIFYSUCESS] = (state, action) => {
    return {
        ...state,
        codeResult:action.payload,
        type:'phoneVerifySuccess'
    }
}
actions[type.PHONE_VERIFYERROR] = (state, action) => {
    return {
        ...state,
        type:'phoneVerifyError'
    }
}
actions[type.PAY_CONFIRMSUCCESS] = (state, action) => {
    return {
        ...state,
        confirmPayResult:action.payload,
        type:'paySuccess'
    }
}
actions[type.PAY_CONFIRMERROR] = (state, action) => {
    return {
        ...state,
        confirmPayResult:null,
        type:'payError'
    }
}
actions[type.SEND_STATE] = (state, action) => {
    let  getSendCode = {
        data:{...action.payload },
        istrue: !state.getSendCode.istrue
    };
    return {
        ...state,
        getSendCode: getSendCode,
        type:'sendCode'
    }
}
actions[type.SET_APPLICANT] = (state, action) => {
    return {
        ...state,
        applicantObj:action.payload,
    }
}
actions[type.SET_INSURED] = (state, action) => {
    return {
        ...state,
        insuredObj:action.payload,
    }
}
export const insuranceSettleReducer = handleActions(actions, initState)
